
import { fromEvent as observableFromEvent } from 'rxjs';

import { debounceTime } from 'rxjs/operators';
import { Component, Input, OnInit, OnDestroy, ElementRef, ViewChild, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { Review } from '../../model/Review';
import { Message } from '../../model/Message';

interface DiscussionMessage extends Message {
  ticks: number;
  userRole?: number;
}

function mapMessage(message: Message): DiscussionMessage {
  if (message.dateParsed) {
    const dateParsed = new Date(message.dateParsed);
    const date = new Date(dateParsed);
    date.setHours(0, 0, 0, 0);
    return {
      ...message,
      ticks: dateParsed.getTime(),
      dateParsed,
      date,
      time: dateParsed.getHours() + ':' + dateParsed.getMinutes()
    };
  }
  const date = message.dateTime.split(' ')[0];
  const time = message.dateTime.split(' ')[1];
  const hour = parseInt(time.split(':')[0], 10);
  const min = parseInt(time.split(':')[1], 10);
  const sec = parseInt(time.split(':')[2], 10);
  const dayOfMonth = parseInt(date.split('/')[0], 10);
  const month = parseInt(date.split('/')[1], 10) - 1;
  const year = parseInt(date.split('/')[2], 10);
  const dateParsed = new Date(year, month, dayOfMonth, hour, min, sec || 0, 0);
  const messageDate = new Date(dateParsed);
  messageDate.setHours(0, 0, 0, 0);
  return {
    ...message,
    ticks: dateParsed.getTime(),
    dateParsed,
    date: messageDate,
    time: time.split(':').slice(0, 2).join(':')
  };
}

@Component({
    selector: 'app-discussion',
    templateUrl: './discussion.component.html',
    styleUrls: ['./discussion.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DiscussionComponent implements AfterViewInit, OnInit, OnDestroy {

  @Input() review!: Review;
  @Input() set isOpen(value: boolean) {
    this.open = value;
    if (value) {
      setTimeout(() => {
        this.sendboxRef.nativeElement.focus();
      }, 250);
    }
  }
  helpVisible = false;
  scrolling = false;
  open = false;
  hasFocus = false;
  @ViewChild('messageRef',) messagesRef!: ElementRef;
  @ViewChild('sendboxRef',) sendboxRef!: ElementRef;
  messages: DiscussionMessage[] = [];
  groupedByDate: { date: Date; messages: DiscussionMessage[] }[] = [];
  sending = false;
  refreshIntervalSeconds = 5;
  refreshTimer: ReturnType<typeof setTimeout> | undefined;
  lastMessageLoad!: Date;


  constructor() { }


  ngOnInit() {
    this.concatMessages(this.review.messages);
    // .sort((a,b) => {
    //  return a.dateTime > b.dateTime ? -1 : 1;
    // });
    observableFromEvent(window, 'resize').pipe(
      debounceTime(100))
      .subscribe(this.scroll.bind(this));

    this.lastMessageLoad = new Date();

  }

  concatMessages(newMessages: Message[]): void {
    this.messages = this.messages.concat(newMessages.map(mapMessage));
    this.makeDateGrouping();
  }

  makeDateGrouping() {
    const distinctDates = this.messages.reduce<Date[]>((acc, message) => {
      if (acc.indexOf(message.date) === -1) {
        acc.push(message.date);
      }
      return acc;
    }, []);

    this.groupedByDate = distinctDates.reduce<{ date: Date; messages: DiscussionMessage[] }[]>((acc, date) => {
      acc.push({ date, messages: this.messages.filter(message => message.date === date) });
      return acc;
    }, []);
  }

  ngAfterViewInit() {
    setTimeout(this.scroll.bind(this));
  }

  ngOnDestroy() {
    clearTimeout(this.refreshTimer);
  }

  scroll() {
    this.messagesRef.nativeElement.scrollTop = this.messagesRef.nativeElement.scrollHeight;
  }


}
